module.exports = __webpack_public_path__ + "assets/fontawesome-webfont.eot";


/*****************
 ** WEBPACK FOOTER
 ** ./~/font-awesome/fonts/fontawesome-webfont.eot?v=4.6.1
 ** module id = 113
 ** module chunks = 0
 **/